import {Avatar, IconButton, Tooltip} from "@mui/material";

const TooltipButton = ({title,icon,action,disabled = false,color = null,type = null}) => {
    return (
        <Tooltip title={title}>
            <IconButton onClick={action} sx={{
                bgcolor: color ? color : 'primary.main',
                width: 20,
                padding:2,
                height:20,
                cursor: 'pointer',
                '&:hover': {bgcolor: type === 'error' ? 'red': 'primary.light'}
            }}>
                {icon}
            </IconButton>
        </Tooltip>
    )
}
export default TooltipButton